module.exports = __webpack_public_path__ + "static/media/NotificationsScreen.679dfec7.png";